import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ApplicationState from "@SupplyLand/Store/ApplicationState";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

const mapStateToProps = (state: ApplicationState) => ({
    pageType: getCurrentPage(state).type,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    widgetGridContainerNoFooter?: GridContainerProps;
    widgetGridContainerNoFooterCheckoutPayAndShip?: GridContainerProps;
    linkBar?: InjectableCss;
    logoGridItem?: GridItemProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    socialLinksGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    logoWrapper?: InjectableCss;
}

export const footerContainerStyles: FooterContainerStyles = {
    logoGridItem: {
        width: 12,
        css: css`
            width: 100%;
            justify-content: center;
            max-width: 300px;
            margin: auto;
        `,
    },
    widgetGridContainer: {
        css: css`
            max-width: 1400px !important;
            margin: auto !important;
            color: white;
            font-size: 12px;
            padding: 1rem;
            letter-spacing: 1.5px;
        `,
    },
    widgetGridContainerNoFooter: {
        css: css`
            max-width: 1400px !important;
            margin: auto !important;
            color: white;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css``,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    widgetGridContainerNoFooterCheckoutPayAndShip: {
        css: css`
            max-width: 1400px !important;
            margin: auto !important;
            color: white;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: block;
                        height: 0px;
                        margin-top: 60px;
                    `,
                    css``,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    linkBar: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css``,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    linkList1GridItem: {
        width: [12, 12, 6, 3, 3],
        css: css`
            text-align: center;
            span {
                color: white !important;
            }
            span :hover {
                color: hsl(0, 0%, 70%) !important;
            }

            img {
                padding: 25px;
                max-width: 300px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 5px;
                        padding-top: 0px;
                    `,
                    css`
                        padding-bottom: 5px;
                        padding-top: 0px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    linkList2GridItem: {
        width: [12, 12, 2, 2, 2],
        css: css`
            padding-top: 70px;
            span {
                color: white !important;
            }
            span :hover {
                color: hsl(0, 0%, 70%) !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 5px;
                        padding-top: 0px;
                    `,
                    css`
                        padding-bottom: 5px;
                        padding-top: 0px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    linkList3GridItem: {
        width: [12, 12, 2, 2, 2],
        css: css`
            padding-top: 70px;
            span {
                color: white !important;
            }
            span :hover {
                color: hsl(0, 0%, 70%) !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 5px;
                        padding-top: 0px;
                    `,
                    css`
                        padding-bottom: 5px;
                        padding-top: 0px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    linkList4GridItem: {
        width: [12, 12, 2, 2, 2],
        css: css`
            padding-top: 70px;
            span {
                color: white !important;
            }
            span :hover {
                color: hsl(0, 0%, 70%) !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 5px;
                        padding-top: 0px;
                    `,
                    css`
                        padding-bottom: 5px;
                        padding-top: 0px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    subscribeGridItem: {
        width: [12, 12, 12, 3, 3],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-top: 10px;
                    `,
                    css`
                        padding-top: 10px;
                    `,
                    css`
                        padding-top: 10px;
                    `,
                    css`
                        padding-top: 70px;
                    `,
                    css`
                        padding-top: 70px;
                    `,
                ])}
        `,
    },
    socialLinksGridItem: {
        width: 12,
        css: css`
            span {
                color: white !important;
            }
            span :hover {
                color: hsl(0, 0%, 70%) !important;
            }
        `,
    },
    siteMapLinksGridItem: {
        width: 12,
        css: css`
            span {
                color: white !important;
            }
            span :hover {
                color: hsl(0, 0%, 70%) !important;
            }
        `,
    },
    richContentGridItem: {
        width: 12,
    },
    logoWrapper: {
        css: css`
            width: auto;
        `,
    },
};

const FooterContainer: FC<Props> = ({ id, extendedStyles, pageType }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    const pageTypesToHideFooter = [
        "CartPage",
        "CheckoutShippingPage",
        "CheckoutReviewAndSubmitPage",
        "OnePageCheckoutPage",
    ];
    const hideFooter = pageTypesToHideFooter.includes(pageType);
    let widgetContainerStyle;
    let linkBar;
    if (!hideFooter) {
        widgetContainerStyle = styles.widgetGridContainer;
    } else {
        linkBar = styles.linkBar;
        switch (pageType) {
            case "CartPage":
                widgetContainerStyle = styles.widgetGridContainerNoFooter;
                break;
            case "OnePageCheckoutPage":
                widgetContainerStyle = styles.widgetGridContainerNoFooterCheckoutPayAndShip;
                break;
            case "CheckoutShippingPage":
                widgetContainerStyle = styles.widgetGridContainerNoFooter;
                break;
            case "CheckoutReviewAndSubmitPage":
                widgetContainerStyle = styles.widgetGridContainerNoFooter;
                break;
            default:
                widgetContainerStyle = styles.widgetGridContainer;
                break;
        }
    }

    return (
        <>
            <StyledWrapper {...styles.linkBar}>
                <Zone contentId={id} zoneName="Content" />
            </StyledWrapper>
            <GridContainer {...widgetContainerStyle}>
                <GridItem {...styles.linkList1GridItem}>
                    <Zone zoneName="LinkList1" contentId={id} />
                </GridItem>
                <GridItem {...styles.linkList2GridItem}>
                    <Zone zoneName="LinkList2" contentId={id} />
                </GridItem>
                <GridItem {...styles.linkList3GridItem}>
                    <Zone zoneName="LinkList3" contentId={id} />
                </GridItem>
                <GridItem {...styles.linkList4GridItem}>
                    <Zone zoneName="LinkList4" contentId={id} />
                </GridItem>
                <GridItem {...styles.subscribeGridItem}>
                    <Zone zoneName="Subscribe" contentId={id} />
                </GridItem>
                <GridItem {...styles.socialLinksGridItem}>
                    <Zone zoneName="SocialLinks" contentId={id} />
                </GridItem>
            </GridContainer>
        </>
    );
};

const footerContainer: WidgetModule = {
    component: connect(mapStateToProps)(FooterContainer),
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;
